"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 12.975L17.026 18l.974-.974L12.975 12 18 6.975 17.026 6 12 11.025 6.975 6 6 6.975 11.025 12 6 17.026l.975.974L12 12.975z" }), "Decline");
//# sourceMappingURL=Decline.js.map